module.exports = __webpack_public_path__ + "img/pentagon.c51d93e4.svg";